<template>
  <!-- <div>
    <div v-if="showContinuePlaceHolder">
      <categoriesPlaceholder :screen="screen"/>
    </div>
      <div :class="[`main-${id}`, 'home-class-main']" v-if="finalPlaylistData && finalPlaylistData.length > 0 && !showContinuePlaceHolder">
        <div class="slider-category-title" v-if="screen && screen.title">{{ localDisplayLang === "es" ? (screen.title.es || screen.title.spa) : screen.title.default }}</div>
        <div class="slider-header">
          <div
            class="seeall"
            @click="seeAll()"
            v-if=" (finalPlaylistData && finalPlaylistData.length > 13)">
            <div class="more"> {{ $t("More") }} </div>
            <div> <img src="@/assets/icons/rightarrow.svg" alt="more" class="seeall-arrow" /> </div>
          </div>
        </div>
        <div :class="['swiper', `ok${id}`]" style="position: relative;padding-right: 4rem;">
          <div class="swiper-wrapper" style="padding-right: 4rem;">
            <div class="swiper-slide portrait-img-view" :id="`swiper-slide-${index}`" v-for="(item, index) of finalPlaylistData" :key="index">
              <categoryCard
                :content="item"
                :percentProgress="item.progress"
                :absoluteProgress="item.watchedduration"
                :displayTags="false"
                :cardType="cardDisplayType"
                :playerInstance="playerInstance"
                @remove="removeDataFromFire"
                :showRemove="true"
                :showTitle="true"
                :isContinueWatch="false"
              ></categoryCard>
            </div>
          </div>
          <div class="swiper-button-next">
            <div class="next-btn-onhover"></div>
          </div>
          <div class="swiper-button-prev">
            <div class="prev-btn-onhover"></div>
          </div>
        </div>
      </div>
  </div> -->
  <div>
    <categoriesPlaceholder :screen="screen" :id="id" v-if="showContinuePlaceHolder"/>
    <Slider 
      v-if="finalPlaylistData && finalPlaylistData.length > 0 && !showContinuePlaceHolder"
      :screen="screen"
      :contentList="finalPlaylistData"
      :screenName="screenName"
      :id="id"
      :title="'top'"
      @reachEnd="reachEnd"
      :screenId="screenId"
      :showRemove="true"
      @remove="removeDataFromFire"
      :fromWatchListSlider="true"
      :showMore="true"
    >
    </Slider>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import { eventBus } from "@/eventBus";
import { getDatabase, ref, get, onValue, onChildAdded, onChildChanged, onChildRemoved } from "firebase/database";
import Utility from "@/mixins/Utility.js";
import FirebaseActions from "@/mixins/FirebaseActions";
import { store } from "@/store/store";

export default {
  props: {
    screen: {
      type: Object,
    },
    playerInstance: {
      type: Object,
    },
    screenId: {
      type: String,
    },    
    screenName: {
      type: String,
    },
    id: {
      type: String,
    },
  },
  data() {
    return {
      continueWatchContent: [],
      finalPlaylistData: [],
      slider: null,
      showContinuePlaceHolder: false,
      detailPlaylist: [],
      finalPlaylist: [],
      availabilities: [],
      subscriptions: [],
      purchases: [],
      contentProgress: null,
      completeEpisodeListing: [],
      playlistIndex: 0,
      continueData: [],
      page: 1,
      isMpegRequired: false,
      totalFirebaseResponse: null,
      displayType: 'PORTRAIT',
      cardDisplayType: {
          cardName: "Slider",
          type: "PORTRAIT",
          height: "100%",
          width: "100%",
          playButton: { enablePlay: false, width: "40px", height: "40px" },
      },
      playlistUnsub: null
    };
  },
  watch: {
    subscriptionList(val) {
      if (val) {
        this.subscriptions = val;
      }
    },
    purchaseList(val) {
      if (val) {
        this.purchases = val;
      }
    },
    localDisplayLang(val) {
      if (val) {
        if (this.slider) {
          if (this.localDisplayLang === "ara") {
            this.slider.goTo("last");
          } else {
            this.slider.goTo("first");
          }
        }
      }
    },
  },
  computed: {
    ...mapGetters([
      "subscriberid",
      "availabilityList",
      "subscriptionList",
      "purchaseList",
      "profileid",
      "getRtl",
    ]),
  },
  created() {
    //assigning subscription list response.
    // this.isMpegRequired = this.checkMpegRequired();
    if (this.subscriptionList !== undefined) {
      this.subscriptions = this.subscriptionList;
    }

    //assinging purchase list response.
    if (this.purchaseList !== undefined) {
      this.purchases = this.purchaseList;
    }

    this.localDisplayLang = localStorage.getItem("setDisplayLanguageCode");

    // eventBus.$on("check-local-storage", (data) => {
    //   this.localDisplayLang = data;
    //   this.showContinuePlaceHolder = true;
    //   this.slider = null;
    //   this.checkPlaylist();
    // });

  },
  updated() {
    setTimeout(() => {
      if (
        this.localDisplayLang === "ara" &&
        this.continueWatchData &&
        this.continueWatchData.length < 5
      ) {
        document.getElementById("continueWatch-carousel-iw")
          ? (document.getElementById(
              "continueWatch-carousel-iw"
            ).style.textAlign = "-webkit-right")
          : "";
      }
    }, 700);
  },
  mounted() {
    console.log('watchList')
    // this.checkPlaylist();
    this.playlistUnsub = this.unSubscribePlaylist();
    // eventBus.$on("on-watchlist-state-change", () => {
    //   this.checkPlaylist();
    // });
    this.showContinuePlaceHolder = true;
    this.constructSlider();
  },
  methods: {
    ...mapMutations(["setContinueWatchData"]),
    ...mapActions(["listContent"]),
    seeAll() {
      let currentLanguage = this.getCurrentLanguageUrlBase();
      this.$router.push({
        name: "Watchlist",
        params: {lang: currentLanguage },
      });
    },
    checkMpegRequired() {
      let isMpegRequired = false;
      let videoTag = document.createElement("video");
      let platformOs = navigator.platform;

      if (videoTag.canPlayType("application/vnd.apple.mpegurl")) {
        if (platformOs.startsWith("Mac")) {
          isMpegRequired = true;
        }
      }

      return isMpegRequired;
    },
    attachFirebaseNodes(content) {
      let index = this.continueData.findIndex((el) => {
        return el.objectid === content.objectid;
      });

      if (index > -1) {
        content.firebaseKeys = this.continueData[index];
      }
    },

    constructSlider() {
      if (this.finalPlaylistData && this.finalPlaylistData.length > 0) {
        let breakpoints = {
          300: {
            slidesPerView: this.displayType == 'PORTRAIT' ? 3 : 2,  // Adjust the number of posters for mobile devices
            spaceBetween: 5  // Adjust the space between posters for mobile devices
          },
          420: {
            slidesPerView: this.displayType == 'PORTRAIT' ? 2.5 : 1.7,  // Adjust the number of posters for mobile devices
            spaceBetween: 5  // Adjust the space between posters for mobile devices
          },
          500: {
            slidesPerView: this.displayType == 'PORTRAIT' ? 3.5 : 2,  // Adjust the number of posters for mobile devices
            spaceBetween: 7  // Adjust the space between posters for mobile devices
          },
          630: {
            slidesPerView: this.displayType == 'PORTRAIT' ? 4 : 2.8,  // Adjust the number of posters for mobile devices
            spaceBetween: 10  // Adjust the space between posters for mobile devices
          },
          768: {
            slidesPerView: this.displayType == 'PORTRAIT' ? 4 : 3,  // Adjust the number of posters for mobile devices
            spaceBetween: 12  // Adjust the space between posters for mobile devices
          },

          992: {
            slidesPerView: this.displayType == 'PORTRAIT' ? 5.2 : 4.5,
            spaceBetween: 20
          },

          1024: {
            slidesPerView: this.displayType == 'PORTRAIT' ? 6.3 : 4.7,
            spaceBetween: 20
          },

          1500: {
            slidesPerView: this.displayType == 'PORTRAIT' ? 7.3 : 6.7,
            spaceBetween: 10
          },
          1800: {
            slidesPerView: this.displayType == 'PORTRAIT' ? 8.3 : 7.1,
            spaceBetween: 10
          }
        }

        // alert(`.ok${this.id}`)
        this.$nextTick(() => {
          let swiper = new window.Swiper(`.ok${this.id}`, {
            slidesPerView: 2,  // Set the number of slides directly for testing
            cssMode: true,
            lazy: true,
            spaceBetween: 10,
            navigation: {
              nextEl: ".swiper-button-next",
              prevEl: ".swiper-button-prev",
            },
            on: {
              init: function () {
                
              },
            },
            breakpoints,
            pagination: {
              el: ".swiper-pagination",
              clickable: true,
            },
          });
          swiper.init();
        })
      }
    },
    removeDataFromFire(data) {
        // this.showContinuePlaceHolder = true;
        this.updateContentWatchlist(data, false).then(() => {
            this.$emit("removedWatchlistContent", true);
        })
        this.finalPlaylistData = this.finalPlaylistData.filter((item, i) => {
          return data.objectid!== item.objectid;
        });
    },
    // checkPlaylist(isDelete = false) {
    //   const db = getDatabase();
    //   const path = `/subscriber/${this.subscriberid}/${this.profileid}/content/`;
    //   const contentRef = ref(db, path);

    //   get(contentRef)
    //     .then((snapshot) => {
    //       if (!snapshot.exists()) {
    //         this.showContinuePlaceHolder = false;
    //         return;
    //       }

    //       const nodeContentArr = this.collectionsToArray(snapshot.val());
    //       this.totalFirebaseResponse = nodeContentArr.filter((element) => element.inwatchlist);

    //       if (this.totalFirebaseResponse.length > 0) {
    //         this.makeTheWatchlistAPIcallClub(this.totalFirebaseResponse);
    //       } else {
    //         this.showContinuePlaceHolder = false;
    //       }
    //     })
    //     .catch((error) => {
    //       console.error("Error fetching playlist:", error);
    //       this.showContinuePlaceHolder = false;
    //     });
    // },
    makeTheWatchlistAPIcallClub(totalContents) {
      let ObjectIdArr = [];
      totalContents.forEach((element, index) => {
        ObjectIdArr.push(`"${element.objectid}"`)
      });
      if (ObjectIdArr && ObjectIdArr.length > 0) {
  
        let payload = {
          contentlist: "[" + `${ObjectIdArr}` + "]",
          displaylanguage: this.localDisplayLang,
          notincontentprovider: ["hotgo"],
          pagesize: "100"
        };
        this.listContent(payload).then((data) => {
          this.finalPlaylistData = data.data.data ? data.data.data : [];
          this.sortWatchList();
          this.showContinuePlaceHolder = false;
          this.constructSlider();
        }).catch((err) =>{
          console.log('watchList', err)
        })
      }
    },
    unSubscribePlaylist() {
      const db = getDatabase();
      const path = `/subscriber/${this.subscriberid}/${this.profileid}/content/`;
      const subsRef = ref(db, path);

      const unsubscribe = onValue(
        subsRef,
        (snapshot) => {
          if (!snapshot.exists()) {
            this.showContinuePlaceHolder = false;
            return;
          }

          const nodeContentArr =
            this.collectionsToArray(snapshot.val()) || [];

          this.totalFirebaseResponse = nodeContentArr.filter(
            (item) => item.inwatchlist
          );

          if (this.totalFirebaseResponse.length > 0) {
            this.makeTheWatchlistAPIcallClub(this.totalFirebaseResponse);
          } else {
            this.showContinuePlaceHolder = false;
          }
        },
        (error) => {
          console.error("Listening playlist error:", error);
          this.showContinuePlaceHolder = false;
        }
      );

      return unsubscribe; // VERY IMPORTANT
    },
    sortWatchList() {
          console.log("vvvv", this.totalFirebaseResponse);
          console.log("vvvv__", this.finalPlaylistData);
          this.totalFirebaseResponse.map((fireBaseItem, fireBaseItemIndex) => {
          this.finalPlaylistData.map((apiItem, apiItemIndex) => {
            if (apiItem.objectid === fireBaseItem.objectid) {
              this.finalPlaylistData[apiItemIndex] = {
                ...apiItem,
                status : fireBaseItem.status,
                updatedat: fireBaseItem.updatedat,
              };
            }
          });
        });
        this.finalPlaylistData = this.finalPlaylistData.sort((a, b) => {
            return b.updatedat - a.updatedat;
          });
    },
    getPoster(content, type) {
      if (Array.isArray(content.poster)) {
        if (content.poster && content.poster.length) {
          let index = content.poster.findIndex((element) => {
            return (element.quality === "SD" || element.quality === "HD") && element.postertype === type;
          });
          let img = 0;
          if (index > -1 && Array.isArray(content.poster[index]?.filelist)) {
            content.poster[index].filelist?.forEach(element => {
              // if (element.quality == 'LOW') {
              // return element.filename
              img = element.filename;
              // }
            });
            if (img) {
              return img
            } else {
              if (type == "LANDSCAPE") {
                return this.placeholder_lands;
              }
              return this.placeholder_port;
            }
          } else {
            if (type == "LANDSCAPE") {
              return this.placeholder_lands;
            }
            return this.placeholder_port;
          }
        }
      } else if (content.inwatchlist) {
        return content.poster.landscape;
      } else if (content.thumbnail) {
        return this.placeholder_port;
      } else {
        if (type == "LANDSCAPE") {
          return this.placeholder_lands;
        }
        return this.placeholder_port;
      }
    },
  },
  beforeDestroy() {
    if (this.playlistUnsub) {
      this.playlistUnsub();
    }

    eventBus.$off("check-for-series-route");
    eventBus.$off("send-episode-list");
    eventBus.$off("check-new-fire-data");
  },
  components: {
    categoriesPlaceholder: () => import(/* webpackchunkname: continueWatchingPlaceholder */ "@/components/placeholders/categoriesPlaceholder.vue"),
    categoryCard: () => import(/* webpackChunkName: "genreDrop" */ "@/components/Templates/categoryCard.vue"),
    Slider: () => import('@/themeearth/components/dashboard/sliderCarousel/Slider.vue'),
  },
  mixins: [Utility, FirebaseActions],
};
</script>

<style scoped lang="scss">
@import "@/sass/_variables.scss";
@import "@/sass/_components.scss";

:root {
  --blue: #1e90ff;
  --white: $clr-saina-light-dark-txtf;
  --VERTICAL-CARD-HOVER-SCALE-X: 0.8;
  --VERTICAL-CARD-HOVER-SCALE-Y: 0.8;
}

.swiper {
  width: 100%;
  height: 100%;
}

.landscape-img-view {
  aspect-ratio: 16 / 9;
}

.portrait-img-view {
  aspect-ratio: 2 / 3;
}

.swiper-slide {
  text-align: center;
  font-size: 18px;
  background: #282828;
  /* background: white; */
  display: flex;
  justify-content: center;
  align-items: center;
  // height: 16rem;
  border-radius: 8px;
  border: 1px solid #282828;
  // pointer-events: none;
  z-index: 9;
  cursor: pointer;

}

.swiper-slide img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: fill;
  border-radius: 8px;
}

.slider-category-title {
  font-size: 1.3rem;
  margin: 0.8rem 0.1rem;
  color: $clr-saina-light-dark-txt;
}

.swiper-button-next-overlay {
  height: 15rem;
  background-image: linear-gradient(to right, rgba(0, 0, 0, 0.85) 30%, rgba(0, 0, 0, 0.0) 90%);
  position: absolute;
  width: 3rem;
  top: 0px;
  display: block;
  z-index: 9999;
  // pointer-events: none;
  margin-top: auto !important;
}

::after {
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  left: 50%;
}

.swiper-button-next-overlay[aria-disabled="true"] .swiper-button-prev-overlay[aria-disabled="true"] {
  background-image: linear-gradient(to right, rgba(0, 0, 0, 0) 30%, rgba(0, 0, 0, 0.85) 90%);
}

.swiper-button-prev-overlay {
  height: 16rem;
  position: absolute;
  width: 3rem;
  top: 0px;
  right: 0;
  display: block;
  z-index: 9999;
  margin-top: auto !important;
}

@keyframes kdUbkV2MkpUdd4wNQxnlN {
  100% {
    opacity: 1;
    transform: scale(1);

  }

  0% {
    opacity: 0;
    transform: scale(0.5);

  }
}

.onhover-poster {
  position: absolute;
  z-index: 999;
  top: -5%;
  /* Initially position below the parent element */
  cursor: pointer;

  .hover-card {
    width: 22rem;
    height: 26rem;
    background: #101113;
    transform-origin: center center;
    animation: kdUbkV2MkpUdd4wNQxnlN 0.6s ease-in;
    position: relative;
    border-radius: 0.5rem;
    box-shadow: 0px 0px 5px 3px #00000073;

    figure {
      width: 100%;
      height: 50%;

      .image__item_video {
        width: 100%;
        height: 100%;
        border-radius: 0.5rem 0.5rem 0 0;
        height: 12rem;
        object-fit: cover;

      }

      .image__item {
        width: 100%;
        height: 100%;
        border-radius: 0.5rem 0.5rem 0;
      }

      .related-meta-data {
        padding: 0.75rem;
        display: flex;
        flex-direction: column;
        gap: 0.5rem;

        .related-action-btns {
          display: flex;
          gap: 1rem;
        }

        .related-meta-data-details {
          display: flex;
          flex-direction: column;
          gap: 0.5rem;

          .fig-title {
            font-weight: 500;
            font-size: 1rem;
          }

          .fig-details {
            display: flex;
            gap: 0.8rem;
            flex-direction: column;

            .main-info {
              display: flex;
              gap: 1rem;
              font-size: 0.85rem;
              align-items: center;

              .publish-year,
              .duration {
                color: #aaaaaa;
              }

              .pgrating {
                border: #3b3a3a 0.8px solid;
                padding: 0.1rem 0.4rem;
                border-radius: 0.2rem;
                color: #ffffff;
              }
            }

            .main-genre {
              display: flex;
              gap: 1rem;
              font-size: 0.85rem;
            }

            .main-genre .sub-genre2 p::before,
            .main-genre .sub-genre3 p::before {
              content: "• ";
              position: relative;
              right: 0.4rem;
            }
          }

          .fig-description {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: pre-wrap;
            color: rgba(170, 170, 170, 1);
            font-weight: 400;
            font-size: 0.8rem;
            height: 3.5rem;
          }
        }
      }
    }
  }

}

.mute-unmute-btn-slider {
  position: absolute;
  right: 1rem;
  bottom: 2rem;
  z-index: 999999;
}

.home-class-main {
  //margin-left: 1rem;
  position: relative;
}


.next-btn-onhover {
  background: #000;
  width: 4rem;
  height: 24rem;
  position: absolute;
  opacity: .2;
  border-radius: 10px;

}

.prev-btn-onhover {
  background: #000;
  width: 4rem;
  height: 24rem;
  position: absolute;
  opacity: .1;
  border-radius: 10px;
}

.slider-header {
  margin-top: 0.5rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 5px 0px 0.7rem;

  .seeall {
    cursor: pointer;
    font-size: 1.2rem;
    font-weight: 600;
    letter-spacing: 0.75px;
    padding: 0 5px;
    transition: 0.1s;
    align-self: center;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    right: 0rem;
    margin-bottom: 3rem;

    &:hover {
      transform: scale(1.05);
      color: $clr-light-gd3;
    }
  }

  .seeall-arrow {
    position: relative;
    top: 0.22rem;
    width: 1rem;
    height: 1.6rem;
  }

  .slider-head {
    display: flex;
    justify-content: flex-end;
    align-items: center;

    .slider-head-btns {
      margin-top: 3px;

      .slider-controls {
        button {
          border: none;
          background: transparent;


          cursor: pointer;

          img {
            height: 1.6rem;
            width: auto;
          }

          &:disabled {
            opacity: 0.3;
            display: flex;
          }

          &:focus {
            outline: none;
          }
        }

        &:focus {
          outline: none;
        }
      }
    }
  }
}

.slider-content {
  .content-slider {
    &:focus {
      outline: none;
    }
  }
}

@media screen and (max-width: 786px) {
  .swiper-button-next, .swiper-button-prev, .more {
    display: none;
  }
  .slider-category-title, .seeall {
    font-size: 0.8rem !important;
    margin: 0.5rem;
    text-transform: uppercase;
    font-weight: 600;
  }

}

@media screen and (min-width: 786px) and (max-width: 1023px) {
 .slider-category-title, .seeall {
    font-size: 0.9rem !important;
    margin: 0.5rem;
    text-transform: uppercase;
    font-weight: 600;
 }
 .badge {
  position: absolute;
  padding: 0.2rem;
  background:$primary-btn-color;
  top: 5px; 
  left: 5px;
  font-size: 0.5rem;
  border-radius: 0.25rem
 }
 .next-btn-onhover, .prev-btn-onhover {
    width: 2.5rem;
    height: 5rem;
  }
  .seeall-arrow {
    font-size: 1rem;
    font-weight: 600;
  }
}
</style>
